module.exports = __webpack_public_path__ + "img/repguide-wartung-screenshots-config.87b0dab1.jpg";